import { MutationTree } from 'vuex';
import { MuseumState } from '@/store/types/museum.state';

export const mutations: MutationTree<MuseumState> = {
    setArtists(state, value) {
        state.artists = value;
    },
    setArtworks(state, value) {
        state.artworks = value;
    },
    setLoading(state, value) {
        state.loading = value;
    },
};
